import React, { useState } from "react";

const PopupDialog = ({ title, isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="overlay">
      <div className="popup">
        <h3>{title}</h3>
        <div className="buttons">
          <button className="button-new positive" onClick={onConfirm}>Confirm</button>
          <button className="button-new negative" onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default PopupDialog;